// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnerItemsContainer_container___Jhq9"};